import { FC, forwardRef, SVGProps } from 'react'
import { Address } from 'viem'
import { SUPPORTED_CHAIN_ID_TO_LOGOS } from '@/config/chain/constants'
import { AccountDisplay } from '@/ui/molecules/account-display/AccountDisplay'
import { LucideIcon } from 'lucide-react'
import { useChainId } from 'wagmi'
import Image from 'next/image'

interface UserProfileButtonProps {
  onClick?: () => void
  address?: Address
  className?: string
  Icon?: LucideIcon | FC<SVGProps<SVGElement>>
  withStatusAlert?: boolean
}

export const UserProfileButton = forwardRef<HTMLButtonElement | HTMLDivElement, UserProfileButtonProps>(
  ({ address, className, Icon, onClick }, ref) => {
    const chainId = useChainId()
    const networkIcon = SUPPORTED_CHAIN_ID_TO_LOGOS[chainId]
    const iconUrl = `https://icons-ckg.pages.dev/stargate-light/networks/${networkIcon}.svg`

    const Wrapper = onClick ? 'button' : 'div'

    return (
      <Wrapper ref={ref as any} {...(onClick ? { onClick } : {})} className={className}>
        <span className="flex items-center gap-2">
          {networkIcon && <Image src={iconUrl} alt="" width={16} height={16} className="rounded-full" />}
        </span>

        <AccountDisplay address={address} />
        {Icon && <Icon className="h-4 w-4 text-muted-foreground transition-colors group-hover:text-foreground" />}
      </Wrapper>
    )
  },
)
UserProfileButton.displayName = 'UserProfileButton'
